import React from 'react';
import QuantityDropdown from '../QuantityDropdown';
import styles from './styles.module.scss';
import enhance from './enhance';
import PriorityLabel from '../PriorityLabel';

export const PrioritiesExpanded = ({
  prioritiesQuantities,
  templateId,
  modelId,
  unsubmittedQuota,
  closeMultiplePriorities,
  openMultiplePriorities,
  multiplePriorities,
  collapsePrioritiesLabel,
  expandPrioritiesLabel,
  disabled,
  priorities,
  textStyle,
}) =>
  multiplePriorities ? (
    <div className={styles.multiplePriorities}>
      {priorities.map(priority => (
        <div key={priority} className={styles.expandedPriorities}>
          <div className={styles.quantitiesDropdown}>
            <QuantityDropdown
              priority={priority}
              templateId={templateId}
              modelId={modelId}
              disabled={disabled}
              quantity={prioritiesQuantities[priority] || 0}
              unsubmittedQuota={unsubmittedQuota}
            />
          </div>
          <PriorityLabel priority={priority} />
        </div>
      ))}
      <div className={styles.buttonContainer}>
        <button
          className={styles.button}
          style={textStyle}
          onClick={closeMultiplePriorities}
        >
          - {collapsePrioritiesLabel}
        </button>
      </div>
    </div>
  ) : (
    <div className={styles.buttonContainerExpand}>
      <button
        className={styles.button}
        style={textStyle}
        onClick={openMultiplePriorities}
      >
        + {expandPrioritiesLabel}
      </button>
    </div>
  );

export default enhance(PrioritiesExpanded);
